(ns client-portal.client.products.views
  (:require [client-portal.client.products.data :as products.d]
            [shared.core.amelia-light.components.components :as alc]
            [shared.core.reactive :as re]
            [shared.core.style :as style]
            [shared.core.util :as util]))

(defn products-dropdown [_]
  (let [products- (re/subscribe [:products/list-])]
    (fn [{:keys [value only-reference-ids] :as args}]
      (let [products (util/when-not-loading @products-)]
        [alc/up-popover-button-dropdown
         (merge (dissoc args :value)
                {:placeholder "Product"
                 :options (some->> products
                                   (filter #(or (empty? only-reference-ids)
                                                (contains? only-reference-ids (:reference-id %))))
                                   (mapv (fn [{:keys [label reference-id]}]
                                           {:text label
                                            :value reference-id
                                            :selected? (= value reference-id)})))})]))))

(defmethod alc/dialog-view
  :products/google-cloud-projects-dialog [_ _]
  (let [project-row (fn [form-name label]
                      [:div {:style {:display :flex
                                     :flex-direction :column
                                     :gap 8}}
                       [:span {:style {:color (style/alc-color "Text/primary_header")
                                       :font-size 14
                                       :font-weight 500}}
                        label]
                       [alc/up-dropdown {:form-path products.d/google-cloud-projects-form-path
                                         :form-name form-name
                                         :options products.d/google-cloud-project-options}]])]
    [alc/dialog {:title "Google Cloud Projects"
                 :footer [:<>
                          [alc/up-call-to-action-button {:on-click #(re/dispatch [:products/save-google-cloud-projects])}
                           "Save"]
                          [alc/up-button {:on-click #(re/dispatch [:dialog/hide])}
                           "Cancel"]]}
     [:div {:style {:display :flex
                    :flex-direction :column
                    :gap 16
                    :width 480}}
      (project-row :oasys-proj "OASYS")
      (project-row :vc-proj "Voice Commerce")]]))
